import api from "./api";

const OrganizationService = {
  getAllOrganizations() {
    return api.get("/api/v1/organization");
  },

  createOrganization(data) {
    return api.post("/api/v1/organization", data);
  },

  updateOrganization(id, data) {
    return api.put(`/api/v1/organization/${id}`, data);
  },

  deleteOrganization(id) {
    return api.delete(`/api/v1/organization/${id}`);
  },

  getOrganizationbyid(id){
    return api.get(`/api/v1/organization/${id}`);
  }
};

export default OrganizationService;
